export default interface IGeronimo {
  country: string;
  dealerId: string;
}
